import { sendRequest } from '../utils';
import { AssetLoaderError } from './error';

interface ManifestJson {
    latest: string;
    current: string;
    lastCommitHash: string;
    versioning: {
        lastExistingVersion: string;
        lastCommitHash: string;
    };
}

interface AssetLoaderConstructorArguments {
    baseUrl?: string;
    assetDirectory: string;
    version?: string;
}

export class AssetLoader {
    public isInitialized = false;

    private baseUrl: string;
    private assetDirectory: string;
    private assetVersion?: string;

    constructor({
        baseUrl = 'https://apps.mews.com/mews-assets/release',
        assetDirectory,
        version,
    }: AssetLoaderConstructorArguments) {
        this.baseUrl = baseUrl;
        this.assetDirectory = assetDirectory;

        if (version) {
            this.isInitialized = true;
            this.assetVersion = version;
        }
    }

    initialize = async (): Promise<void> => {
        if (this.isInitialized) {
            return Promise.resolve();
        }

        if (process.env.NODE_ENV === 'test') {
            this.isInitialized = true;
            this.assetVersion = '46.0.0';
            return Promise.resolve();
        }

        const manifestUrl = `${this.baseUrl}/manifest.json`;

        try {
            const { latest }: ManifestJson = await sendRequest(manifestUrl, { method: 'GET', autoContentType: true });
            this.isInitialized = true;
            this.assetVersion = latest;
        } catch (ex) {
            throw new AssetLoaderError(`Unable to load manifest.json from ${manifestUrl} (${ex})`);
        }
    };

    getAssetSrc = (assetName: string) => {
        if (!this.isInitialized) {
            throw new AssetLoaderError('Latest release was not loaded and the exact version was not provided');
        }

        return `${this.baseUrl}/${this.assetVersion}/${this.assetDirectory}/${assetName}`;
    };
}
